module.exports = __webpack_public_path__ + "img/kr-channel-banner.524957d7.png";